<template>
  <span
    class="v3-loading-button-wrap d-inline-flex flex-column align-items-center"
  >
    <!-- assertive + non-empty idle text: polite/empty status regions are often not announced when loading starts on the same tick as the button click (WCAG 4.1.3). -->
    <span
      class="visually-hidden"
      role="status"
      aria-live="assertive"
      aria-atomic="true"
    >
      {{ a11yStatusText }}
    </span>
    <BaseButton
      :type="type"
      v-bind="$attrs"
      :is-disabled="isLoading || disabled"
      :aria-busy="isLoading"
      class="v3-loading-button w-100"
      :class="[{ loading: isLoading }, buttonLayoutClass]"
      :prepend-icon="isLoading ? 'ri-loader-4-line' : ''"
      :append-icon="appendIcon"
      :rounded="rounded"
      :solid="solid"
      @click="$emit('click', $event)"
      ><slot></slot
    ></BaseButton>
  </span>
</template>

<script>
import BaseButton from "./BaseButton.vue"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

export default {
  inheritAttrs: false,
  components: { BaseButton },
  emits: ["click"],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    appendIcon: String,
    rounded: Boolean,
    solid: Boolean,
    /** Native `<button type>` — forwarded to BaseButton (e.g. `submit` in forms). */
    type: {
      type: String,
      default: "button",
      validator: (v) => ["button", "submit", "reset"].includes(v)
    }
  },
  setup(props) {
    const { t } = useI18n()
    const submittingLabel = computed(() => t("common.form_submitting"))
    /** Non-breaking space keeps a text descendant so `role="status"` is valid when idle (ARIA). */
    const a11yStatusText = computed(() =>
      props.isLoading ? submittingLabel.value : "\u00a0"
    )
    return { a11yStatusText }
  }
}
</script>

<style></style>
